'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterAccordion = function FooterAccordion(el) {
  (0, _classCallCheck3.default)(this, FooterAccordion);

  this.els = {
    el: el,
    lists: (0, _functional.getElements)('.ft-Columns_Item:not(.ft-Columns_Item-noAccordion)', {
      context: el
    })
  };

  this.els.lists.forEach(function (el) {
    el.querySelector('.ft-Columns_Title').addEventListener('click', function (e) {
      e.preventDefault();

      el.classList.toggle('ft-Columns-active');
    });
  });
};

exports.default = FooterAccordion;